import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Select, Table, Tabs, Tooltip, message } from 'antd';
import { FloatingLabel } from 'flowbite-react';
import { FaSave } from "react-icons/fa";
import Axois from '../utils/axios';
import { Link, useLoaderData, useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import EventEmitter from '../utils/eventEmitter';
import AddAccountModal from '../modals/AddAccountModal';
import useBudgetaryPositionAPI from '../apis/budgetaryPositionAPI.js';



const columns = [
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Account Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
]


const BudgetaryPositionChanges = () => {
  const { success, error } = useOutletContext();
  const {accounts, position } = useLoaderData();
  const params = useParams();
  const navigate = useNavigate();
  const { save } = useBudgetaryPositionAPI();
  const [name, setName] = useState(position.name ? position.name : '');
  const [selectedAccounts, setSelectedAccounts] = useState(position.accounts ? position.accounts : []);


  const onChangeName = e => setName(e.target.value);

  const handleSubmit = async() => {
    // save(formValue);
    let data = {name: name};
    data['seo'] = name.replace(/ /g, '-').toLowerCase();
    data['accounts'] = selectedAccounts.map(account => account._id);
    save(data);
  }


  useEffect(() => {
    EventEmitter.subscribe('budgetary_position_accounts', data => {
      setSelectedAccounts(data);
      // navigate('/accounting/budgetary-positions/'+data.seo.replaceAll('/', '-'));
    });

    EventEmitter.subscribe('position_response', data => {
      
    });

    return () => {
      EventEmitter.unsubscribe('budgetary_position_accounts');
      EventEmitter.unsubscribe('position_response');
    }
  },[])

  const addEntry = () => EventEmitter.dispatch('add_account_modal', true);
  
  return (
    <div className='container mx-auto' style={{maxWidth: '900px'}}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/accounting/budgetary-positions'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Budgetary Positions</Link> / {params.action}
          </h3>
          <Tooltip title={'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleSubmit} type='text' htmlType='button'
              disabled={ position.name ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        {position.name && <Button>UPDATE</Button>}
      </div>
      <div className='mt-5 bg-white p-3'>
        <FloatingLabel 
          className='text-2xl' 
          variant="standard" 
          label="Budgetary Position Name" 
          value={name} 
          onChange={onChangeName}
        />

          <Tabs
            type="card"
            items={[
              {
                key: '1',
                label: 'Accounts',
                children: 
                  <>
                    <Table 
                      sticky
                      columns={columns}
                      dataSource={selectedAccounts}
                      scroll={{ y: 400,}}
                      pagination={false}
                      rowKey={'code'}
                    />
                    <Button onClick={addEntry}>Add Entry</Button>
                  </>
              },
            ]}
          />
      </div>
      <AddAccountModal accounts={accounts} />
    </div>
  )
}
export default BudgetaryPositionChanges;